videojs.addLanguage('fr', {
  "AddCaptureButton": "Ajouter une vignette",
  "AddChapterButton": "Ajouter un chapitre",
  "AddImageButton": "Ajouter une image",
  "index": "Index",
  "AddQuestionButton": "Ajouter une question",
  "AddQuizButton": "Ajouter un quiz",
  "AddSondageButton": "Ajouter un sondage",
  "AddAnnotationButton": "Ajouter une annotation",
  "slide": "Diapositive",
  "AddVideoButton": "Ajouter une vidéo",
  "SaveButton": "Enregistrer",
  "chapter": "Chapitre",
  "image": "Image",
  "question": "Question",
  "quiz": "Quiz",
  "hidden-area": "Zone cachée",
  "CTAButton": "Appel à agir",
  "AddHiddenAreaButton": "Ajouter une zone cachée",
  "PreviewButton": "Aperçu"
});


//////////////////
// WEBPACK FOOTER
// ./plugin/videojs_ultimate/dist/lang/fr.js
// module id = 973
// module chunks = 0